<script>
import resources from './resources'

export default {
  name: 'disabled-account',
  mixins: [resources]
}
</script>

<template lang="pug">
  .row
    .form-group.col-md-offset-3.col-md-6.col-sm-12(:class="{'has-error is-empty': $v.credentials.current_password.$error}")
      input.form-control.text-center(
        type='password',
        name='current_password',
        v-model="credentials.current_password")
      p.help-block(v-if='$v.credentials.current_password.$error')
          strong
            | Senha obrigatória

    .form-group.col-md-12.col-sm-12(style="text-align: center;", v-show="isPasswordError")
      p(style="color: #A94443; font-size: 10px;")
        strong
          | Ocorreu um erro ao autenticar, verifique sua senha.

    button.btn.save.btn-margin-alert(@click.prevent="accountDisable()")
      span.icon 
      | Desativar Conta
</template>



// WEBPACK FOOTER //
// src/app/settings/profile/components/disabled-account/disabled-account.vue